import React from 'react';
import { useParams } from 'react-router-dom';

import DetalleNoticiaFabrica from '../detalle-noticia-fabrica/DetalleNoticiaFabrica';
import DetalleNoticiaEstacion from '../detalle-noticia-estacion/DetalleNoticiaEstacion';
import DetalleNoticiaHistorica from '../detalle-noticia-historica/DetalleNoticiaHistorica';

const NoticiaRouteHandler = () => {
  const { slug } = useParams<{ slug: string }>();

  const layouts: Record<string, React.ComponentType> = {
    'historica-fabrica-de-gas-dara-paso-a-barrio-sustentable': DetalleNoticiaHistorica,
    'adultos-mayores-de-estacion-central-visitaron-los-gasometros': DetalleNoticiaEstacion,
  };

  const ComponentToRender = (slug && layouts[slug]) || DetalleNoticiaFabrica;

  return <ComponentToRender />;
};

export default NoticiaRouteHandler;